import { Modal } from "flowbite";
import Toastify from "toastify-js";

const removeStudents = () => {
  // elements
  const form = document.getElementById("delete_students");
  if (form) {

    const inputElements = form.querySelectorAll("input[type=checkbox]");
    const inputSubmit = form.querySelector("button[type=submit]");
    const modalButtonConfirm = document.getElementById("confirmStudentRemoveConfirm");
    const modalButtonDeny = document.getElementById("confirmStudentRemoveDeny");
    const output = document.querySelector(".count");

    // configs
    const toastOptions = {
      duration: 1500,
      gravity: "bottom",
      position: "right",
      className: "rounded-md shadow",
      style: { background: "#000000" },
    };
    const modalOptions = {
      placement: "center-center",
      backdrop: "static",
      closable: true,
    };

    // modal
    const modal = new Modal(document.getElementById("confirmStudentRemove"),modalOptions);

    // handle onchange events of inputs
    function handleInputChange(event) {
      let count = getCheckedInputCount();
      if (count == 0) {
        output.textContent = `Select a learner, or many learners...`;
        inputSubmit.disabled = true;
      } else {
        output.textContent = `${count} ${
          count === 1 ? "student" : "students"
        } selected`;
        inputSubmit.disabled = false;
      }
    }
    inputElements.forEach((el) => {
      el.addEventListener("input", handleInputChange);
    });

    // get count of all checked input elements
    const getCheckedInputCount = () => {
      return Array.from(inputElements).filter((input) => input.checked).length;
    };

    // get all checked input elements
    const getCheckedInputIds = () => {
      return Array.from(inputElements)
        .filter((input) => input.checked)
        .map((input) => input.value);
    };

    // events
    modalButtonConfirm.addEventListener("click", (e) => {
      e.preventDefault();
      // get the form data
      const data = new FormData(form);
      data.append("action", "delete_students");
      data.append("ids", getCheckedInputIds());
      // fetch
      fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then((response) => {
          modal.hide();
          Toastify({
            text: response.data.message,
            ...toastOptions,
            callback: () => {
              location.reload();
            },
          }).showToast();
        })
        .catch((error) => {
          console.error(error);
        });
    });
    modalButtonDeny.addEventListener("click", (e) => {
      e.preventDefault();
      modal.hide();
    });
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      modal.show();
    });

  }
};

export { removeStudents };
